export default "__VITE_ASSET__BV7q3zgx__"